import * as z from 'zod';

export const DomesticColdWaterSchema = z.object({
  otherWaterLoads: z.string().optional(),
  hadPipeLeaks: z.boolean().optional(),
});

export type DomesticColdWater = z.infer<typeof DomesticColdWaterSchema>;
